import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { 
  IEmpresaResponse, 
  IEmpresaRequest, 
  IEmpresaSaveRequest, 
  IEmpresaSaveResponse,
  IEmpresaDetalleResponse
} from '../interfaces/empresa.interface';

@Injectable({
  providedIn: 'root'
})
export class EmpresaService {
  private readonly API_URL_LIST = `${environment.apiNewBackBaseUrl}ParametrosEmpresas/cmspa_cianegList`;
  private readonly API_URL_LIST_DET = `${environment.apiNewBackBaseUrl}ParametrosEmpresas/cmspa_cianegListDet`;
  private readonly API_URL_SAVE = `${environment.apiNewBackBaseUrl}ParametrosEmpresas/cmspa_cianegAdd`;
  private readonly API_URL_UPDATE = `${environment.apiNewBackBaseUrl}ParametrosEmpresas/cmspa_cianegUpd`;
  private readonly API_URL_DELETE = `${environment.apiNewBackBaseUrl}ParametrosEmpresas/cmspa_cianegDelete`;

  constructor(private http: HttpClient) { }

  getEmpresas(request: IEmpresaRequest): Observable<IEmpresaResponse> {
    return this.http.post<IEmpresaResponse>(this.API_URL_LIST, request);
  }

  getEmpresaByIdentificador(identificador: string): Observable<IEmpresaDetalleResponse> {
    const payload: IEmpresaRequest = {
      que: 5,
      tope: "",
      identificador: identificador,
      nombre: '',
      calle: '',
      numext: '',
      numint: '',
      ciudad: '',
      del_muni: '',
      cve_estado: '',
      estatus: '',
      telefono: '',
      telefono2: '',
      scoring: 0,
      politica: '',
      comentario: ''
    };
    return this.http.post<IEmpresaDetalleResponse>(this.API_URL_LIST_DET, payload);
  }

  saveEmpresa(payload: IEmpresaSaveRequest): Observable<IEmpresaSaveResponse> {
    return this.http.post<IEmpresaSaveResponse>(this.API_URL_SAVE, payload);
  }

  updateEmpresa(payload: IEmpresaSaveRequest): Observable<IEmpresaSaveResponse> {
    return this.http.post<IEmpresaSaveResponse>(this.API_URL_UPDATE, payload);
  }

  deleteEmpresa(identificador: string): Observable<IEmpresaSaveResponse> {
    const payload: IEmpresaSaveRequest = {
      que: 3,
      tope: '',
      identificador: identificador,
      nombre: '',
      calle: '',
      numext: '',
      numint: '',
      ciudad: '',
      del_muni: '',
      cve_estado: '',
      estatus: '',
      telefono: '',
      telefono2: '',
      scoring: 0,
      politica: '',
      comentario: ''
    };
    return this.http.post<IEmpresaSaveResponse>(this.API_URL_DELETE, payload);
  }
} 